import { EvolutionDataset } from "../EvolutionDataset"
import { ChartDataSets, ChartPoint } from "chart.js"
import { FreeMemoryEvolutionApiResponse } from "../../../api/MaintenanceRequests"

export const getFreeMemoryEvolutionDataset = (data: FreeMemoryEvolutionApiResponse): EvolutionDataset => {
    const dataset: ChartDataSets = {
        borderColor: "rgba(28,95,220,0.63)",
        backgroundColor: "rgba(220,4,151,0)",
        label: "Mémoire libre",
        lineTension: 0,
        data: []
    };
    
    const dates:Array<Date> = new Array<Date>()
    
    data.forEach(it => {        
        const dateString:string = it.date
        const date:Date = new Date(dateString)
        
        dates.push(date);
    
        (dataset.data as ChartPoint[]).push({
            x: date,
            y: Math.round(it.freeMemory)

        })
        
    })

    return {
        datasets: [dataset],
        dates: dates,
        error: undefined,
        labels: undefined,
        maxValue: undefined
    }
}